// Exports
// -------

export default function getAssignmentCourseId(assignment) {
  if (!assignment) {
    return;
  }

  if (!assignment.course?.course_id) {
    return `${assignment.tutor_id}-${assignment.skill?.subject_id}`;
  }

  return assignment.course.course_id;
}
